import React from 'react';

import SetoCanvasPage from 'pages/SetoCanvasPage';
import SearchInput from 'views/SearchInput';
import {Separator} from 'views/AppElements';

class _404 extends React.Component {

	render() {
		return (
				<SetoCanvasPage id="_404Page" title="404 Not Found | Seto Canvas">
					<h1 style={{textAlign: "center", color: "gray"}}>
						<i className="fa fa-cloud" aria-hidden="true" style={{color: "#949699"}}></i> 404 Not Found
					</h1>

					
					<Separator />
					<SearchInput title="Try Searching Below" />
				</SetoCanvasPage>
			);
	}
}


export default _404;


// WEBPACK FOOTER //
// ./src/pages/404.js